import { actionTypes } from './actionTypes';

export const setNewlyCreatedTeam = newlyCreatedTeam => {
  return {
    type: actionTypes.SET_NEWLY_CREATED_TEAM,
    newlyCreatedTeam,
  };
};
